export const SIDEBAR = {
  bg: "#F7F9FC",
  text: "#304055",
  muted: "#6B7A90",
  border: "#E2E8F0",
};

export const CATEGORY_ACCENT = {
  home: { main: "#0F4C81", soft: "#E8F1F8" },
  inventory: { main: "#0C7C74", soft: "#E6F4F3" },
  nonInventory: { main: "#5C6F91", soft: "#EEF2F8" },
  repairs: { main: "#C76A0A", soft: "#FFF4E8" },
  security: { main: "#D14343", soft: "#FDECEC" },
  gatepass: { main: "#1E88A8", soft: "#E8F6FA" },
  finance: { main: "#2E8B57", soft: "#EAF7EF" },
  reports: { main: "#1D4ED8", soft: "#EEF2FF" },
  settings: { main: "#6D5BD0", soft: "#F3F0FC" },
};

export const categoryIconWellSx = (module) => ({
  minWidth: 40,
  "& .MuiSvgIcon-root": {
    fontSize: 18,
    color: module.main,
    bgcolor: module.soft,
    borderRadius: "8px",
    padding: "5px",
    boxSizing: "content-box",
  },
});

const moduleRowSx = (module) => ({
  color: SIDEBAR.text,
  bgcolor: "transparent",
  borderRadius: 0,
  borderLeft: "3px solid transparent",
  "&:hover": {
    bgcolor: module.soft,
  },
  "&.Mui-selected": {
    bgcolor: module.soft,
    color: SIDEBAR.text,
    "&:hover": {
      bgcolor: module.soft,
    },
  },
  "&.Mui-selected .MuiListItemText-primary": {
    fontWeight: 600,
    color: SIDEBAR.text,
  },
});

export const withModuleParentSx = (module, active = false, extra = {}) => [
  {
    color: SIDEBAR.text,
    bgcolor: "transparent",
    borderRadius: 0,
    borderLeft: "3px solid transparent",
    "&:hover": {
      bgcolor: module.soft,
    },
  },
  active
    ? {
        bgcolor: module.soft,
        borderLeft: "3px solid",
        borderColor: module.main,
        "&:hover": {
          bgcolor: module.soft,
        },
        "& .MuiListItemText-primary": {
          fontWeight: 600,
          color: SIDEBAR.text,
        },
      }
    : null,
  extra,
];

export const withModuleChildSx = (module, extra = {}) => [moduleRowSx(module), extra];

export const withModuleLeafSx = (module, extra = {}) => [
  {
    color: SIDEBAR.text,
    bgcolor: "transparent",
    borderRadius: 0,
    borderLeft: "3px solid transparent",
    "&:hover": {
      bgcolor: module.soft,
    },
    "&.Mui-selected": {
      bgcolor: module.soft,
      color: SIDEBAR.text,
      borderLeft: "3px solid",
      borderColor: module.main,
      "&:hover": {
        bgcolor: module.soft,
      },
    },
    "&.Mui-selected .MuiListItemText-primary": {
      fontWeight: 600,
      color: SIDEBAR.text,
    },
  },
  extra,
];

export const moduleIconSx = (_module, fontSize = 20) => ({
  fontSize,
  color: SIDEBAR.muted,
});

export const sectionLabelSx = (_module) => ({
  pl: 3,
  pt: 1,
  pb: 0,
  fontSize: 11,
  fontWeight: 600,
  letterSpacing: "0.08em",
  textTransform: "uppercase",
  color: SIDEBAR.muted,
});

export const expandedRailSx = (_module) => ({
  ml: 3,
  pl: 0.5,
  borderLeft: "1px solid",
  borderColor: SIDEBAR.border,
});

export const sidebarDividerSx = {
  borderColor: SIDEBAR.border,
};
